























import { mixins } from "vue-class-component";
import { Component, Prop, Vue } from "vue-property-decorator";
import { NavBar, Row, Icon, Button } from "vant";
import WeMixin from "@/components/weMixin";
import { CoreModule } from "@/store/modules/core";

@Component({
  components: {
    [NavBar.name]: NavBar,
    [Row.name]: Row,
    [Icon.name]: Icon,
    [Button.name]: Button,
  },
})
export default class ClearCachePage extends mixins(WeMixin) {
  protected doClear() {
    CoreModule.clearAuth();
    this.$toast.success("清理成功");
  }
}
